<script>
    import DataTable, {Body, Head, Row, Cell} from "@smui/data-table";

    import Currency from "../component/Currency.svelte";

    import {globalState} from '../store/store.js';

    import {getValidatedDateYear} from "./Calculate.js";

    /** @type (array) result array from API */
    export let result = undefined;
    export let simulatorVacation = false;
    export let strong = false;

    let year = null
    for (const [key, value] of Object.entries($globalState)) {
        /*if ('s' === key) {
            simulatorVacation = value;
        }*/
        if ('n' === key) {
            year = getValidatedDateYear(value);
        }
    }

    const baseYearlyVacancy = 12; //10.85

    function getValue(result, key, period = "monthly") {
        let periodFactor = 1;
        if (simulatorVacation) {
            periodFactor = period === "yearly" && key !== "dailyRate" ? baseYearlyVacancy : 1;
        } else {
            periodFactor = period === "yearly" && key !== "dailyRate" ? 12 : 1;
        }

        return result[key] * periodFactor;
    }

    let days = parseInt(getValue(result, "daysPerMonth") * 12);
</script>
<DataTable table$aria-label="slideyear-one" style="width: 100%;">
    <Head>
        <Row>
            <Cell as="th" colspan="2" style="text-align: center;background-color: #002b5c">
                <span class="orange">
                    Annuel
                    {#if simulatorVacation}
                        avec CP
                    {/if}
                    <br/>
                    <span>
                        {#if simulatorVacation}
                            10,85 mois
                        {:else}
                            12 mois
                        {/if}
                        ({days} jours)
                        <!--({daysPerMonthForYearFake(simulatorVacation, year, "yearly")} jours)-->
                    </span>
                </span>
            </Cell>
        </Row>
    </Head>
    <Body>
    <Row style="height: 25px;">
        <Cell>TJM</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "dailyRate", "yearly")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Facturation</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "invoiceAmount", "yearly")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Brut</Cell>
        <Cell style="text-align: right">
            {#if strong}
                <strong>
                    <Currency number={getValue(result, "totalBaseGross", "yearly")}/>
                </strong>
            {:else}
                <Currency number={getValue(result, "totalBaseGross", "yearly")}/>
            {/if}
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Net<span class="super">*</span> + Frais</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "netToPayBeforePAS", "yearly")}/>
        </Cell>
    </Row>
    <!--{#if privateVersion}-->
    <Row style="height: 25px;">
        <Cell>PAS</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "pasAmount", "yearly")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Net<span class="super">**</span> + Frais</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "netToPayAfterPAS", "yearly")}/>
        </Cell>
    </Row>
    <!--{/if}-->
    </Body>
</DataTable>
